/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import uuid from 'uuid';
import { FrameSection, FrameItem } from '@ccxi/ccxi-shared-components/src/HeaderFooterBase';
import Header from '@ccxi/ccxi-shared-components/src/Header';
import HeaderNameComponent from '@ccxi/ccxi-shared-components/src/HeaderNameComponent';
import Link from '@react/react-spectrum/Link';
import Icons from '../../../../utils/iconMapping';
import { PDPAnalytics } from '../../../../analytics';
import TranslationUtil from '../../../../utils/translation';

class TutorialHeader extends Component {
    onViewMoreClick(e, viewMore) {
        const { data: { tutorials: { sectionId }, actionHandlerCallback } } = this.props;
        const guid = uuid.v4();
        const actionParam = {
            actionObject: viewMore,
            guid,
        };
        actionHandlerCallback(
            e, sectionId, viewMore.actionId, actionParam
        );

        PDPAnalytics.viewMoreTutorialClick(viewMore, guid, sectionId);
    }

    renderLeftSection() {
        const { data: { tutorials: { sectionName } } } = this.props;
        return (
            <FrameSection position="left" className="tutorial-header-left">
                <FrameItem>
                    <HeaderNameComponent headerName={sectionName} />
                </FrameItem>
            </FrameSection>
        );
    }

    renderRightSection() {
        const { data: { tutorials: { viewMore } } } = this.props;
        const { LinkOut } = Icons;
        if (!viewMore || !viewMore.actionId) {
            return null;
        }
        return (
            <FrameSection
                position="right"
                tabIndex={0}
                role="link"
                aria-label="View More"
                className="tutorial-header-right"
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        this.onViewMoreClick(e, viewMore);
                    }
                }}
                onClick={(e) => { this.onViewMoreClick(e, viewMore); }}>
                <FrameItem className="view-more">
                    <Link>
                        {TranslationUtil.getMessage('ccx.pdp.view-more')}
                    </Link>
                </FrameItem>
                <FrameItem className="link-out-icon">
                    <LinkOut />
                </FrameItem>
            </FrameSection>
        );
    }

    render() {
        return (
            <Header className="tutorial-header">
                {this.renderLeftSection()}
                {this.renderRightSection()}
            </Header>
        );
    }
}

export default observer(TutorialHeader);
